import { render, staticRenderFns } from "./BonusSendRecordPane.vue?vue&type=template&id=649a2892&scoped=true"
import script from "./BonusSendRecordPane.vue?vue&type=script&lang=js"
export * from "./BonusSendRecordPane.vue?vue&type=script&lang=js"
import style0 from "./BonusSendRecordPane.vue?vue&type=style&index=0&id=649a2892&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a2892",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('649a2892')) {
      api.createRecord('649a2892', component.options)
    } else {
      api.reload('649a2892', component.options)
    }
    module.hot.accept("./BonusSendRecordPane.vue?vue&type=template&id=649a2892&scoped=true", function () {
      api.rerender('649a2892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/BonusSend/BonusSendRecordPane.vue"
export default component.exports